<template>
    <modal ref="modal">
        <div id="sub-wrapper">
            <div class="count">{{ countStr() }}</div>
            <div class="participants">
                <div v-for="participant in participants" :key="participant.id">
                    <button class="button-2" v-if="!participant.enabled" @click="onToggleEnabled(participant)">
                        <font-awesome-icon icon="user-plus"/>
                        {{ $t('modals.call_room_participants.add') }}
                    </button>
                    <button v-else @click="onToggleEnabled(participant)">
                        <font-awesome-icon icon="user-minus"/>
                        {{ $t('modals.call_room_participants.eject') }}
                    </button>
                    {{ participant.name }}
                    <font-awesome-icon class="microphone" icon="microphone" v-if="participant.enabled && !participant.muted" @click='onToggleMuted(participant)'/>
                    <font-awesome-icon class="microphone" icon="microphone-slash" v-if="participant.enabled && participant.muted" @click='onToggleMuted(participant)'/>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { callRoom } from '@/services/call_room'

export default {
  props: {
    count: Number,
    participants: Array
  },
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    },
    countStr () {
      var d
      var n = 'modals.call_room_participants.count.'
      if (this.count === 0) n += '0'
      else if (this.count === 1) n += '1'
      else {
        d = { n: this.count }
        n += 'several'
      }
      return this.$t(n, d)
    },
    onToggleEnabled (participant) {
      // Update participant
      callRoom.updateParticipant(participant.id, !participant.enabled)
        .catch(() => { this.$parent.$parent.$parent.$refs.toaster.error(this.$i18n.t('errors.default')) })
    },
    onToggleMuted (participant) {
      // Update participant
      callRoom.updateParticipant(participant.id, null, !participant.muted)
        .catch(() => { this.$parent.$parent.$parent.$refs.toaster.error(this.$i18n.t('errors.default')) })
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 30em;
}

#sub-wrapper .count {
  margin-bottom: 2em;
}

#sub-wrapper .participants {
  text-align: left;
}

#sub-wrapper .participants > div {
  margin-bottom: 0.3em;
}

#sub-wrapper .participants > div:last-child {
  margin-bottom: 0;
}

#sub-wrapper button {
    font-size: 0.9em;
    line-height: 2.7em;
    margin-right: 0.3em;
    padding: 0;
    width: 6.5em;
}

#sub-wrapper .button-2 {
    background-color: #7c7c7c;
    color: #ffffff;
}

#sub-wrapper .button-2:hover {
    background-color: #8c8c8c;
    color: #ffffff;
}

#sub-wrapper button > svg {
  margin-right: 0.3em;
}

#sub-wrapper .microphone {
  cursor: pointer;
  color: #666666;
  width: 1.5em;
}

</style>
